import { siteConfig } from "@/config/siteConfig";

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <span className={`grid shrink-0 place-items-center overflow-hidden rounded-xl shadow-lg shadow-brand/30 ${className}`}>
    <img src="/img/favicon-192.png" alt="" aria-hidden="true" className="h-full w-full object-cover" />
  </span>
);

export const Logo = ({ dark = false, onClick }) => (
  <a
    href="/#top"
    onClick={onClick}
    data-testid="logo-link"
    aria-label="Salihli Oto Çekici — Ana Sayfa"
    className="flex shrink-0 items-center"
  >
    <img
      src={siteConfig.logoUrl}
      alt="Salihli Oto Çekici logo"
      className="h-10 w-auto rounded-lg md:h-11"
      width="308"
      height="88"
    />
  </a>
);
